export const OPEN_MODAL_CREATE_ACTION = "OPEN_MODAL_CREATE_ACTION";
export const OPEN_MODAL_TARGETED_PRODUCTS = "OPEN_MODAL_TARGETED_PRODUCTS";
export const OPEN_MODAL_ADD_PRODUCTS_USING_FILTERS = "OPEN_MODAL_ADD_PRODUCTS_USING_FILTERS";
export const OPEN_MODAL_DONE = "OPEN_MODAL_DONE";
export const OPEN_MODAL_BACK = "OPEN_MODAL_BACK";
export const OPEN_MODAL_UNDO_CHANGES = "OPEN_MODAL_UNDO_CHANGES";
export const OPEN_MODAL_COLLECTION_CHANGE_CONFIRM_MODAL = "OPEN_MODAL_COLLECTION_CHANGE_CONFIRM_MODAL";
export const OPEN_MODAL_SWITCHING_PLAN = "OPEN_MODAL_SWITCHING_PLAN";
export const OPEN_MODAL_COLLECTION = "OPEN_MODAL_COLLECTION";
export const OPEN_MODAL_EXPORT_ACTIONS = "OPEN_MODAL_EXPORT_ACTIONS";
export const OPEN_MODAL_SYNC = "OPEN_MODAL_SYNC";
export const OPEN_MODAL_UPSELL = "OPEN_MODAL_UPSELL";
export const OPEN_MODAL_NOTIFICATION_PREVIEW = "OPEN_MODAL_NOTIFICATION_PREVIEW";
export const OPEN_MODAL_COLLECTION_WARNING = "OPEN_MODAL_COLLECTION_WARNING";
export const OPEN_MODAL_FETCH_PROGRESS = "OPEN_MODAL_FETCH_PROGRESS"
export const OPEN_MODAL_DUPLICATED_PRODUCTS = "OPEN_MODAL_DUPLICATED_PRODUCTS"